import $axios from "@/api";

const groupUrl = "mitra"

const state = () => ({
})

const mutations = {
}

const actions = {
    getListMitra( {state, commit }, payload) {
        return new Promise( (resolve, reject) => {
            $axios.get(`mitra/list/simple`, {
                params: payload
            }).then((response) => {
                resolve(response.data.data)
            })
        })
    },
    async list({},filters) {
        try{
            const response =  await $axios.get(`${groupUrl}`,{params: filters})  
            return response.data
        }catch(error){
            console.log(error)
        }
    },
    async store({}, payload) {
        try{
            const response =  await $axios.post(`${groupUrl}`,payload)  
            return response
        }catch(error){
            console.log(error)
        }
    },
    async update({}, payload) {
        try{
            const { id, ...inputs } = payload;
            const response =  await $axios.put(`${groupUrl}/${id}`,inputs)
            return response
        }catch(error){
            console.log(error)
        }
    },
    async delete({}, id) {
        try{
            await $axios.delete(`${groupUrl}/${id}`)
        }catch(error){
            console.log(error)
        }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}